import { FC, useEffect, useMemo, useState } from 'react';

import { useFormikContext } from 'formik';
import { debounce } from 'lodash';
import usePlacesService from 'react-google-autocomplete/lib/usePlacesAutocompleteService';
import type { GroupBase, OptionsOrGroups } from 'react-select';
import { Autocomplete } from 'ui/components/form';
import { LocationIcon } from 'ui/components/icon';
import { SIZE } from 'utils/constants';

import { EVENT_FORM } from '../schema';

const AddLocation: FC = () => {
  const [locationSearch, setLocationSearch] = useState('');

  const { setFieldValue, errors, touched, values } =
    useFormikContext<EVENT_FORM>();

  const { placePredictions, getPlacePredictions } = usePlacesService({
    apiKey: import.meta.env.VITE_APP_GOOGLE_MAPS_KEY,
    options: {
      componentRestrictions: { country: import.meta.env.VITE_DEFAULT_COUNTRY },
    },
  });

  useEffect(() => {
    getPlacePredictions({ input: locationSearch });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationSearch]);

  const locationItems = useMemo(
    () =>
      placePredictions?.map((place) => ({
        label: place?.description,
        value: place?.description,
      })) ?? [],
    [placePredictions],
  );

  const debouncedSearch = debounce((string) => setLocationSearch(string), 400);

  const loadOptions = (
    inputValue: string,
    callback: (options: OptionsOrGroups<unknown, GroupBase<unknown>>[]) => void,
  ) => {
    debouncedSearch(inputValue);

    callback(locationItems as any[]);
  };

  return (
    <>
      <div className="flex items-center py-3">
        <LocationIcon className="mr-4 h-5 w-5 text-content" />
        <Autocomplete
          className="w-full"
          onChange={(val: any) => {
            setFieldValue('location', val?.value);
          }}
          state={errors.location && touched.location ? 'danger' : undefined}
          subText={
            errors.location && touched.location ? errors.location : undefined
          }
          onInputChange={(e) => setLocationSearch(e)}
          defaultValue={values?.location}
          size={SIZE.Small}
          name="location"
          placeholder="Search Location"
          loadOptions={loadOptions}
        />
      </div>
      {errors?.location && touched?.location && (
        <p className="text-danger-base">{errors.location}</p>
      )}
    </>
  );
};

export default AddLocation;
